import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";

interface ByzGrdDeleteButtonProps extends React.ComponentProps<typeof Button> {
  onClick?: () => void;
  link?: string;
  loading?: boolean;
}

const StyledButton = styled(Button)<{ disabled?: boolean }>(({ theme, disabled }) => ({
  width: "35px",
  height: "35px",
  borderRadius: "100px",
  padding: 0,
  minWidth: "unset",
  backgroundColor: disabled ? "#AEADA6" : "#B20003",
  transition: "background-color 0.2s ease-in-out, opacity 0.2s ease-in-out",
  boxShadow: disabled
    ? "none"
    : "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  opacity: disabled ? 0.6 : 1,
  "&:hover": {
    backgroundColor: disabled ? "#AEADA6" : "#AE4242",
  },
}));

const ByzGrdDeleteButton: React.FC<ByzGrdDeleteButtonProps> = ({
  onClick,
  link,
  loading,
  disabled,
}) => {
  const [hover, setHover] = useState(false);

  const buttonContent = loading ? (
    <CircularProgress size={16} color="inherit" />
  ) : (
    <img
      src="/assets/icons/delete/delete.svg"
      alt="Sil"
      style={{
        width: "16px",
        height: "16px",
        transition: "opacity 0.2s ease-in-out",
        opacity: hover ? 0.9 : 1,
      }}
    />
  );

  const isDisabled = disabled || loading;

  return link ? (
    <Link to={link} style={{ textDecoration: "none", pointerEvents: isDisabled ? "none" : undefined }}>
      <StyledButton
        disabled={isDisabled}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {buttonContent}
      </StyledButton>
    </Link>
  ) : (
    <StyledButton
      disabled={isDisabled}
      onClick={isDisabled ? undefined : onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {buttonContent}
    </StyledButton>
  );
};

export default ByzGrdDeleteButton;
